await import('C:/Users/bntech/Desktop/workspace/bn-seleium-web/node_modules/.pnpm/@umijs+bundler-webpack@4.6._47332e5f7521c952261a85055f277539/node_modules/@umijs/bundler-webpack/client/client/client.js');
await import('C:/Users/bntech/Desktop/workspace/bn-seleium-web/src/.umi/umi.ts');
export default 1;